var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "third-custom-fields" },
    [
      _vm.hasLabel
        ? _c("h4", { staticClass: "gray-60 m-0 mt-3 mb-2" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("upperCase")(
                    _vm.$l10n.__(
                      "%s - CHAMPS PERSONNALISÉS OBLIGATOIRES",
                      _vm.typeLabel
                    )
                  )
                ) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.groupedCustomFields, function(group, groupIndex) {
        return [
          group.id !== 0
            ? _c(
                "article",
                { key: group.id, class: { "mt-5": groupIndex !== 0 } },
                [
                  _c("header", [
                    _c("h6", { staticClass: "semibold gray-60 fs-3" }, [
                      _vm._v(_vm._s(_vm._f("upperCase")(group.name)))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(group.fields, function(field, index) {
                    return _c(
                      "el-form-item",
                      {
                        key: field.id,
                        ref:
                          "groupedCustomFields." +
                          groupIndex +
                          ".fields." +
                          index +
                          ".value",
                        refInFor: true,
                        attrs: {
                          prop:
                            "groupedCustomFields." +
                            groupIndex +
                            ".fields." +
                            index +
                            ".value",
                          label: field.name,
                          rules: field.rules
                        }
                      },
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(field.name) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            field.description.length
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "pabsolute right--4 top-1",
                                    attrs: {
                                      effect: "dark",
                                      "popper-class":
                                        "form-fields-customfields-tool-tip",
                                      placement: "bottom-start"
                                    }
                                  },
                                  [
                                    _c("div", {
                                      attrs: { slot: "content" },
                                      domProps: {
                                        innerHTML: _vm._s(field.description)
                                      },
                                      slot: "content"
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "icon-rounded-question-fillout"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("cf-" + field.type, {
                          tag: "component",
                          attrs: {
                            parameters: field.parameters,
                            value: field.value,
                            type: field.type,
                            id: field.id
                          },
                          on: { input: _vm.updateValue }
                        })
                      ],
                      2
                    )
                  })
                ],
                2
              )
            : _vm._l(group.fields, function(field, index) {
                return _c(
                  "el-form-item",
                  {
                    key: field.id,
                    ref:
                      "groupedCustomFields-" +
                      groupIndex +
                      "-fields-" +
                      index +
                      "-value",
                    refInFor: true,
                    attrs: {
                      prop:
                        "groupedCustomFields." +
                        groupIndex +
                        ".fields." +
                        index +
                        ".value",
                      label: field.name,
                      rules: field.rules
                    }
                  },
                  [
                    _c(
                      "template",
                      { slot: "label" },
                      [
                        _c("span", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(field.name) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        field.description.length
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "pabsolute right--4 top-1",
                                attrs: {
                                  effect: "dark",
                                  placement: "bottom-start"
                                }
                              },
                              [
                                _c("div", {
                                  attrs: { slot: "content" },
                                  domProps: {
                                    innerHTML: _vm._s(field.description)
                                  },
                                  slot: "content"
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "icon-rounded-question-fillout"
                                })
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("cf-" + field.type, {
                      tag: "component",
                      attrs: {
                        parameters: field.parameters,
                        value: field.value,
                        type: field.type,
                        id: field.id
                      },
                      on: { input: _vm.updateValue }
                    })
                  ],
                  2
                )
              })
        ]
      }),
      _vm._v(" "),
      _vm.allowAdd
        ? _c(
            "CompassButton",
            {
              staticClass: "wp-10 mt-2",
              attrs: {
                label: _vm.$t.__(
                  "thirds.thirdscomponents.FormFieldsCustomFields.add_custom_field"
                ),
                type: "secondary",
                disabled: !_vm.available,
                "data-bot": _vm.getDatabot("add-cf", _vm.currentStore, "cf")
              },
              on: {
                click: function($event) {
                  _vm.showCustomFieldsModal = true
                }
              }
            },
            [
              !_vm.available
                ? _c(
                    "template",
                    { slot: "prefix" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass:
                            "pabsolute form-fields-custom-fields-el-tooltip",
                          attrs: {
                            content: _vm.$t.__(
                              "thirds.thirdscomponents.FormFieldsCustomFields.no_custom_field_available"
                            ),
                            effect: "dark",
                            placement: "top"
                          }
                        },
                        [_c("div", { staticClass: "pabsolute wp-10" })]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("custom-fields-modal", {
        ref: "customFieldsModal",
        attrs: {
          visible: _vm.showCustomFieldsModal,
          currentStore: _vm.currentStore,
          customFields: _vm.customfields
        },
        on: {
          close: function($event) {
            _vm.showCustomFieldsModal = false
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }